import React, { useState, useEffect, useRef } from "react";
import "./paymentgetway.css";
import "./rightside.css";
import axios from "axios";
import { FaAngleDown, FaAngleUp, FaCheck, FaLock, FaExclamationTriangle } from "react-icons/fa";
import { IoCloseOutline } from "react-icons/io5";
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaTruck } from "react-icons/fa";
import { FiChevronRight } from "react-icons/fi";

import useNotification from "../../utils/useNotification";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Loading, Navbar, Navbar2 } from "../../common";
import {
  add_user_check_product,
  check_coupons,
  check_coupons_v2,
  cheke_state,
  cheke_state_v2,
  createOrder_test,
  createOrder_test_v2,
  get_product_details,
  get_product_details_v2,
  get_url_data,
  get_url_data_v2,
  member_view,
  member_view_v2,
  products_url,
} from "../../utils/Constant";
import images from "../../constants/images";
import usStates from "../../constants/usStates.json";
import { RiContactsFill, RiDiscountPercentLine } from "react-icons/ri";
import { MdOutlineCelebration, MdOutlinePayment } from "react-icons/md";
import { CiStar } from "react-icons/ci";

const Checkout2 = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleExpandClick = () => {
    setIsExpanded(!isExpanded);
  };
  const navigate = useNavigate();
  const location = useLocation();
  const { ID } = useParams();

  const name_data = location.state?.name_data;

  const handleGoBack = () => {
    navigate(-1); // This will navigate to the previous page
  };

  const [isloading, setIsLoading] = useState(false);
  const [isemailLoading, setIsEmailLoading] = useState(false);
  const [iscityloading, setIsCityLoading] = useState(false);
  const [getdata, setdata] = useState({});
  const [getproductPrice, setProductPrice] = useState("");
  const [getcdata, setCdata] = useState({});
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [address, setAddress] = useState("");
  const [aptSuite, setAptSuite] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("United States");
  const [getstate, setState] = useState([]);
  const [postalCode, setPostalCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [billingSameAsShipping, setBillingSameAsShipping] = useState(false);
  const [shippingMethod, setShippingMethod] = useState("FREE SHIPPING");
  const [getcardid, setCardid] = useState(1);
  const [cardNumber, setCardNumber] = useState("");
  const [cardholdername, setcardholdername] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [exMonth, setExMonth] = useState("");
  const [exYear, setExYear] = useState("");
  const [cvv, setCvv] = useState("");
  const [id, setId] = useState(null);
  const activeProductId = id || ID;
  const [price, setPrice] = useState(null);
  // const [getcampaignID, setCampaignID] = useState("");
  const [uniqueId, setUniqueId] = useState(null);
  const [getorder_id, setorder_id] = useState(null);
  const [getskipModel, setSkipModel] = useState(false);
  const [showCardDeclinedModal, setShowCardDeclinedModal] = useState(false);
  const [cardDeclinedMessage, setCardDeclinedMessage] = useState("");
  const [showStateRestrictedModal, setShowStateRestrictedModal] = useState(false);

  const [discount_percent, setdiscount_percent] = useState(null);
  const [discount_amount, setdiscount_amount] = useState(null);

  // section 2 conditions
  const [getsection2, setSection2] = useState(false);
  const [sameAsShipping, setSameAsShipping] = useState(true); // Default to same address

  //billing address start
  const [country2, setCountry2] = useState("");
  const [firstName2, setFirstName2] = useState("");
  const [lastName2, setLastName2] = useState("");
  const [address2, setAddress2] = useState("");
  const [city2, setCity2] = useState("");
  const [getselectedState2, setSelectedState2] = useState({
    name: "",
    state_code: "",
  });
  const [getselectedStateCode2, setSelectedStateCode2] = useState({
    name: "",
    state_code: "",
  });
  const [stateError, setStateError] = useState("");
  const [stateError2, setStateError2] = useState("");
  const [postalCode2, setPostalCode2] = useState("");
  const [phoneNumber2, setPhoneNumber2] = useState("");

  // promocode
  const [discountCode, setDiscountCode] = useState("");
  const [appliedDiscount, setAppliedDiscount] = useState(null);
  const [eligibleProducts, setEligibleProducts] = useState([]);
  const [error, setError] = useState("");
  const [couponManuallyRemoved, setCouponManuallyRemoved] = useState(false);
  const [summer150AutoApplied, setSummer150AutoApplied] = useState(false);

  // Helper function to parse numbers that may have commas (e.g., "1,486.00")
  const parseNumber = (value) => {
    if (!value) return 0;
    // Remove commas and parse
    const cleaned = String(value).replace(/,/g, '');
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? 0 : parsed;
  };

 // Helper function to get API endpoint based on ID
 const getApiEndpoint = (regularEndpoint, v2Endpoint) => {
  return ID && parseInt(ID) > 1000 ? v2Endpoint : regularEndpoint;
};

  // check_coupons start
  const handleApplyDiscount = async (couponCode = null) => {
    setError(""); // Clear previous errors
    setApplyLoading(true); // Start loading

    // Use the passed couponCode parameter or fall back to the state value
    // Ensure we always have a string value
    let codeToApply = couponCode || discountCode;

    // Convert to string if it's not already and handle edge cases
    if (codeToApply !== null && codeToApply !== undefined) {
      if (typeof codeToApply === "object") {
        console.error("codeToApply is an object:", codeToApply);
        setApplyLoading(false);
        setError("Invalid discount code format");
        return;
      }
      codeToApply = String(codeToApply);
    }

    console.log("handleApplyDiscount called with:", {
      couponCode,
      discountCode,
      codeToApply,
      type: typeof codeToApply,
      couponCodeType: typeof couponCode,
      discountCodeType: typeof discountCode,
    });

    // Validate that we have a code to apply and ensure it's a string
    if (
      !codeToApply ||
      typeof codeToApply !== "string" ||
      !codeToApply.trim()
    ) {
      setApplyLoading(false);
      setError("Please enter a discount code");
      console.log("Validation failed:", {
        codeToApply,
        type: typeof codeToApply,
      });
      return;
    }

    // Additional validation to ensure it's not [object Object]
    if (codeToApply === "[object Object]" || codeToApply.includes("[object")) {
      setApplyLoading(false);
      setError("Invalid discount code format");
      console.error("Detected [object Object] in codeToApply:", codeToApply);
      return;
    }

    try {
      // Replace this URL with your actual API endpoint
      const response = await axios.post(getApiEndpoint(check_coupons, check_coupons_v2), {
        promo_codes: codeToApply,
        amount: getproductPrice,
        product_id: id || ID,
      });

      // Check the API response status
      if (response.data.status == 1) {
        const eligible = Array.isArray(response.data.eligible_products)
          ? response.data.eligible_products
          : [];
        const failed = Array.isArray(response.data.failed_products)
          ? response.data.failed_products
          : [];

        if (Array.isArray(response.data.eligible_products) && eligible.length === 0) {
          setApplyLoading(false);
          setAppliedDiscount(null);
          setEligibleProducts([]);
          setdiscount_percent(null);
          setdiscount_amount(null);
          setError("This discount code does not apply to these products");
          notifyError("This discount code does not apply to these products");
          return;
        }

        setApplyLoading(false);
        console.log("responce.data", response.data);
        const appliedCode =
          response.data.code || response.data.data?.code || codeToApply.trim();
        setAppliedDiscount(appliedCode);
        setEligibleProducts(eligible);

        const percentValue = response.data.discount_percent;
        let amountValue = response.data.discount_amount;
        const parsedPercent = parseNumber(percentValue);
        let parsedAmount = parseNumber(amountValue);

        if (parsedPercent <= 0 && parsedAmount <= 0 && eligible.length > 0) {
          parsedAmount = eligible.reduce(
            (sum, item) => sum + parseNumber(item?.coupon_amount),
            0
          );
          amountValue = parsedAmount;
        }

        if (parsedPercent > 0) {
          setdiscount_percent(parsedPercent.toFixed(2));
        } else {
          setdiscount_percent(null);
        }

        if (parsedAmount > 0) {
          setdiscount_amount(parsedAmount.toFixed(2));
        } else {
          setdiscount_amount(null);
        }

        setCouponManuallyRemoved(false);
        notifySuccess(
          failed.length > 0
            ? "Discount applied to eligible products."
            : "Discount code applied successfully!"
        );
      } else {
        setApplyLoading(false);
        setAppliedDiscount(null);
        setEligibleProducts([]);
        setdiscount_percent(null);
        setdiscount_amount(null);
        setError("Invalid discount code");
        notifyError("Invalid discount code");
      }
    } catch (err) {
      setApplyLoading(false);
      setError("Something went wrong. Please try again.");
      console.error("API Error:", err);
    }
  };
  // check_coupons end

  // Remove discount handler
  const handleRemoveDiscount = () => {
    setDiscountCode(""); // Clear the discount code input
    setAppliedDiscount(null); // Reset applied discount state
    setEligibleProducts([]);
    setdiscount_percent(0); // Reset discount percent
    setdiscount_amount(0); // Reset discount amount
    setError(""); // Clear any error messages
    setApplyLoading(false); // Reset loading state
    setCouponManuallyRemoved(true); // Mark that user manually removed the coupon
    setSummer150AutoApplied(false); // Reset auto-application flag to allow manual codes
  };

  // promocode end

  // Helper function to calculate discounted price
  const calculateDiscountedPrice = (price) => {
    if (!price || isNaN(price)) return 0;
    
    const parsedPrice = parseNumber(price);
    const parsedPercent = discount_percent ? parseNumber(discount_percent) : 0;
    const parsedAmount = discount_amount ? parseNumber(discount_amount) : 0;
    
    // Debug logging
    console.log("calculateDiscountedPrice:", {
      originalPrice: price,
      parsedPrice,
      discount_percent,
      parsedPercent,
      discount_amount,
      parsedAmount,
      finalPrice: parsedPercent > 0 
        ? parsedPrice - (parsedPrice * parsedPercent / 100)
        : parsedAmount > 0 
        ? parsedPrice - parsedAmount
        : parsedPrice
    });
    
    // Use percentage discount if it exists and is greater than 0
    // Otherwise use amount discount
    if (parsedPercent > 0) {
      const discounted = parsedPrice - (parsedPrice * parsedPercent / 100);
      return Math.max(0, discounted); // Ensure non-negative
    } else if (parsedAmount > 0) {
      const discounted = parsedPrice - parsedAmount;
      return Math.max(0, discounted); // Ensure non-negative
    }
    
    return parsedPrice;
  };

  const getProductCouponAmount = (product) => {
    const match = eligibleProducts.find(
      (item) => String(item?.product_id) === String(product?.product_id)
    );
    return match ? parseNumber(match.coupon_amount) : 0;
  };

  // Determine if a discount is applied
  const isDiscountApplied = () => {
    const parsedPercent = discount_percent ? parseNumber(discount_percent) : 0;
    const parsedAmount = discount_amount ? parseNumber(discount_amount) : 0;
    return parsedPercent > 0 || parsedAmount > 0;
  };

  // Detect plan duration in months:
  // - Supports text: "3/6/12 month(s)" and "3/6/12 month supply"
  // - BM codes: BM:4 -> 3 months, BM:5 -> 6 months, BM:6 -> 12 months
  const getMonthsForProduct = (product) => {
    const desc = (product?.product_description || "").toLowerCase();
    const monthsFromTextMatch = desc.match(/\b(3|6|12)\s*month(s)?(\s*supply)?\b/);
    const monthsFromText = monthsFromTextMatch ? parseInt(monthsFromTextMatch[1], 10) : null;
    return (
      monthsFromText ??
      (desc.includes("bm:6")
        ? 12
        : desc.includes("bm:5")
        ? 6
        : desc.includes("bm:4")
        ? 3
        : 1)
    );
  };

  const months = getMonthsForProduct(getdata);
  const checkoutProducts = Array.isArray(getdata) ? getdata : [];
  const isMultiProduct = checkoutProducts.length > 1;
  const isWeightLossCheckout = isMultiProduct
    ? checkoutProducts.some((item) => item?.product_category_name === "Weight Loss")
    : getdata?.product_category_name === "Weight Loss";

  // Total text logic
  const totalText = isDiscountApplied() ? "Your total" : "Your total";
  // const totalText = isDiscountApplied ? "Latest price" : "Your total";

  const [applyLoading, setApplyLoading] = useState(false);

  // check terms start
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  // check terms end

  const validateEmail = (email) => {
    // Basic email validation regex
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const { notifySuccess, notifyError } = useNotification();

  // Function to handle URL parameters and redirect logic
  const handleUrlRedirect = () => {
    // URL handling logic
    function getParam(n) {
      return new URLSearchParams(location.search).get(n);
    }
    function decodeCData(c) {
      try {
        return decodeURIComponent(atob(c));
      } catch (e) {
        return "";
      }
    }

    const cdata = getParam("cdata");
    const rpageRaw = getParam("rpage");
    console.log("rpageRaw", rpageRaw);
    if (rpageRaw) {
      const rpage = decodeURIComponent(rpageRaw);
      let params = {};
      if (cdata) {
        const entries = new URLSearchParams(decodeCData(cdata));
        console.log("entries", entries);

        params["__usState"] = entries.get("shipping_state") || "";
        params["__phoneNumber"] = entries.get("phone") || "";
        params["__email"] = entries.get("email") || "";
        params["__fullName[first]"] = entries.get("fname") || "";
        params["__fullName[last]"] = entries.get("lname") || "";
      }
      const qs = new URLSearchParams(params).toString();
      const targetUrl = qs
        ? rpage + (rpage.includes("?") ? "&" : "?") + qs
        : rpage;
      window.history.pushState(null, "", location.href);
      window.onpopstate = function () {
        location.href = targetUrl;
      };
    }
  };

  const product = location.state?.product;
  const contact_details_id = location.state?.contact_details_id;

  const fetchStates = () => {
    // Use local JSON file instead of API
    setState(usStates);
    console.log("States loaded from local JSON:", usStates);
  };

  const FetchProduct = async (id) => {
    setIsLoading(true);
    const params = {
      product_id: id,
    };

    await axios
      .post(getApiEndpoint(get_product_details, get_product_details_v2), params)
      .then((res) => {
        setIsLoading(false);
        console.log("res.data", res.data);
        if (res.data.status == 1) {
          const productData = res.data.product_data;
          if (Array.isArray(productData)) {
            if (productData.length === 0) {
              setdata({});
              navigate("/ErrorPage");
              return;
            }
            if (productData.length === 1) {
              setdata(productData[0]);
              setProductPrice(productData[0]?.product_price);
            } else {
              const totalPrice = productData.reduce(
                (sum, item) => sum + parseNumber(item?.product_price),
                0
              );
              setdata(productData);
              setProductPrice(totalPrice.toFixed(2));
            }
          } else {
            setdata(productData);
            setProductPrice(productData?.product_price);
          }
          console.log(productData);
        } else {
          setdata({});
          setdata("");
          navigate("/ErrorPage");
        }
      })
      .catch((err) => {
        setIsLoading(false);

        console.log("err", err);
      });
  };

  const FetchCdata = async (cdata) => {
    setIsLoading(true);
    await axios
      .post(getApiEndpoint(get_url_data, get_url_data_v2), {
        data: cdata,
      })
      .then((Response) => {
        setIsLoading(false);
        if (Response.data.status == 1) {
          setIsLoading(false);
          console.log("Response.data.decoded_data", Response.data.decoded_data);
          const data = Response.data.decoded_data;
          // console.log("data", data);

          setEmail(data?.email);
          setFirstName(data?.fname);
          setLastName(data?.lname);
          setPhoneNumber(data?.phone);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log("eeror------>", error);
      });
  };

  useEffect(() => {
    const currentUrl = window.location.href;

    // Parse the URL to extract query parameters
    const params = new URLSearchParams(new URL(currentUrl).search);

    // Get the 'uniqueId' parameter
    const id = params.get("uniqueId");
    const cdata = params.get("cdata");

    console.log("id", id);
    console.log("cdata", cdata);
    // Set the extracted 'uniqueId' to state
    setUniqueId(id);

    const urlParams = new URLSearchParams(window.location.search);
    const idValue = urlParams.get("id");

    const loadProduct = async () => {
      const skuParam = params.get("sku");

      if (skuParam) {
        const skus = skuParam
          .split(",")
          .map((sku) => sku.trim())
          .filter(Boolean);

        if (skus.length === 0) {
          navigate("/ErrorPage");
          return;
        }

        setIsLoading(true);
        try {
          const response = await axios.get(products_url);
          const products = response.data?.product;

          if (response.data?.status != 1 || !Array.isArray(products)) {
            setIsLoading(false);
            navigate("/ErrorPage");
            return;
          }

          const productIds = [];
          for (const sku of skus) {
            const match = products.find((product) => product.product_sku === sku);
            if (!match?.product_id) {
              setIsLoading(false);
              navigate("/ErrorPage");
              return;
            }
            productIds.push(match.product_id);
          }

          const resolvedProductId = productIds.join(",");
          setId(resolvedProductId);
          FetchProduct(resolvedProductId);
        } catch (err) {
          setIsLoading(false);
          console.log("err", err);
          navigate("/ErrorPage");
        }
        return;
      }

      // Set the extracted ID in the state
      if (ID) {
        setId(ID);
      }
      console.log("ID", ID);
      FetchProduct(ID);
    };

    const fname = params.get("fname");
    const lname = params.get("lname");
    const emailParam = params.get("email");
    const phoneParam = params.get("phone");

    if (fname && fname.trim()) {
      setFirstName(fname.trim());
    }
    if (lname && lname.trim()) {
      setLastName(lname.trim());
    }
    if (emailParam && emailParam.trim()) {
      const trimmedEmail = emailParam.trim();
      setEmail(trimmedEmail);
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      setValidEmail(emailRegex.test(trimmedEmail));
    }
    if (phoneParam && phoneParam.trim()) {
      const digits = phoneParam.replace(/\D/g, "");
      const normalizedPhone = digits.length > 10 ? digits.slice(-10) : digits;
      if (normalizedPhone) {
        setPhoneNumber(normalizedPhone);
      }
    }

    // set c data with api
    if (cdata) {
      FetchCdata(cdata);
    }

    fetchStates();

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
    console.log("location.state", location.state);
    loadProduct();
    // handleUrlRedirect();
  }, []);

  // useEffect(() => {
  //   // Get the query string from the URL
  //   const queryParams = new URLSearchParams(window.location.search);

  //   // Extract the 'id' parameter
  //   const idValue = queryParams.get("id");

  //   // Set the extracted ID in the state
  //   if (idValue) {
  //     setId(idValue);
  //   }

  //   console.log("id", id);
  // }, []);

  const [getallCitys, setAllCitys] = useState([]);
  const [getselectedState, setSelectedState] = useState({
    name: "",
    state_code: "",
  });
  const [getselectedStateCode, setSelectedStateCode] = useState({
    name: "",
    state_code: "",
  });

  // google map start
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);

  var initializeAutocomplete = () => {
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      console.error("Google Maps API not available.");
      setIsLoading(false);
      return;
    }

    const parseAddressComponents = (place) => {
      let stateName = "";
      let stateCode = "";
      let city = "";
      let postalCode = "";

      if (place && place.address_components) {
        // Loop through address components to extract desired fields
        place.address_components.forEach((component) => {
          const types = component.types;
          if (types.includes("administrative_area_level_1")) {
            // State Name and Code
            stateName = component.long_name;
            stateCode = component.short_name; // Short name is usually the state code
          }
          if (types.includes("locality")) {
            // City
            city = component.long_name;
          }
          if (types.includes("postal_code")) {
            // Postal Code
            postalCode = component.long_name;
          }
        });
      }

      return { stateName, stateCode, city, postalCode };
    };

    const cleanAddress = (formattedAddress, componentsToRemove) => {
      // let cleanedAddress = formattedAddress;

      // componentsToRemove.forEach((component) => {
      //   if (component) {
      //     cleanedAddress = cleanedAddress
      //       .replace(component, "")
      //       .replace(/,\s*,/, ",")
      //       .trim();
      //   }
      // });

      // // Remove trailing commas and extra spaces
      // cleanedAddress = cleanedAddress
      //   .replace(/(^,)|(,$)/g, "")
      //   .replace(/\s{2,}/g, " ")
      //   .trim();

      // return cleanedAddress;

      // Split the address by commas and take only the first part
      const addressParts = formattedAddress.split(",");
      return addressParts[0].trim(); // Extracts only the first part (like "Tennessee")
    };

    // Initialize Autocomplete for the first input
    if (inputRef1.current) {
      const autocomplete1 = new window.google.maps.places.Autocomplete(
        inputRef1.current,
        {
          types: ["geocode"], // Restrict to address-type predictions
          componentRestrictions: { country: "us" },
        }
      );

      autocomplete1.addListener("place_changed", () => {
        const place = autocomplete1.getPlace();
        console.log("Place details (input 1):", place);

        if (place) {
          const { stateName, stateCode, city, postalCode } =
            parseAddressComponents(place);

          const cleanedAddress = cleanAddress(place.formatted_address, [
            city,
            stateName,
            postalCode,
          ]);

          console.log("stateName", stateName);
          console.log("stateCode", stateCode);
          console.log("postalCode", postalCode);
          console.log("city-->sZ", city);

          if (stateName && stateCode) {
            // Check if state is Louisiana or Mississippi
            const restrictedStates = ["LOUISIANA", "MISSISSIPPI"];
            if (restrictedStates.includes(stateName.toUpperCase())) {
              setShowStateRestrictedModal(true);
              setSelectedState({ name: "", state_code: "" });
              setSelectedStateCode({ name: "", state_code: "" });
              return;
            }
            // Clear error if valid state selected
            setStateError("");
            setSelectedState({ name: stateName, state_code: stateCode });
            setSelectedStateCode({ name: stateName, state_code: stateCode });
            // AllCitys(stateName);
          }

          if (city) {
            console.log("city---->", city);
            setCity(city); // Assuming you still need city
            setPostalCode("");
          }

          if (postalCode) {
            setPostalCode(postalCode); // Assuming you still need postal code
          }

          setAddress(cleanedAddress); // Set full address
          // setAddress(place.formatted_address); // Set full address
        }
      });
    }

    // Initialize Autocomplete for the second input
    if (inputRef2.current) {
      const autocomplete2 = new window.google.maps.places.Autocomplete(
        inputRef2.current,
        {
          types: ["geocode"], // Restrict to address-type predictions
          componentRestrictions: { country: "us" },
        }
      );

      autocomplete2.addListener("place_changed", () => {
        const place = autocomplete2.getPlace();
        console.log("Place details (input 2):", place);

        if (place) {
          const { stateName, stateCode, city, postalCode } =
            parseAddressComponents(place);

          const cleanedAddress = cleanAddress(place.formatted_address, [
            city,
            stateName,
            postalCode,
          ]);

          if (stateName && stateCode) {
            // Check if state is Louisiana or Mississippi
            const restrictedStates = ["LOUISIANA", "MISSISSIPPI"];
            if (restrictedStates.includes(stateName.toUpperCase())) {
              setShowStateRestrictedModal(true);
              setSelectedState2({ name: "", state_code: "" });
              setSelectedStateCode2({ name: "", state_code: "" });
              return;
            }
            // Clear error if valid state selected
            setStateError2("");
            setSelectedState2({ name: stateName, state_code: stateCode });
            setSelectedStateCode2({ name: stateName, state_code: stateCode });
            // AllCitys(stateName);
          }

          if (city) {
            setCity2(city); // Assuming you need city for second input
            setPostalCode2("");
          }

          if (postalCode) {
            setPostalCode2(postalCode); // Assuming you need postal code for second input
          }

          // setAddress2(place.formatted_address); // Set full address for second input
          setAddress2(cleanedAddress);
        }
      });
    }

    setIsLoading(false);
  };

  // use Effects for checking gmap

  useEffect(() => {
    if (!getsection2 && inputRef1.current) {
      initializeAutocomplete();
    }
  }, [getsection2, inputRef1]);
  useEffect(() => {
    if (getsection2 && inputRef2.current) {
      initializeAutocomplete();
    }
  }, [getsection2, inputRef2]);
  useEffect(() => {
    if (!sameAsShipping && inputRef2.current) {
      initializeAutocomplete();
    }
  }, [sameAsShipping, inputRef2]);
  useEffect(() => {
    if (!isloading && inputRef2.current) {
      initializeAutocomplete();
    }
  }, [isloading, inputRef2]);
  useEffect(() => {
    if (!isloading && inputRef1.current) {
      initializeAutocomplete();
    }
  }, [isloading, inputRef1]);

  useEffect(() => {
    console.log("Updated state code:", getselectedStateCode);
  }, [getselectedStateCode]);

  useEffect(() => {
    const loadScript = (url, callback) => {
      const existingScript = document.querySelector(`script[src="${url}"]`);

      if (!existingScript) {
        const script = document.createElement("script");
        script.src = url;
        script.async = true;
        script.onload = callback;
        script.onerror = () => {
          console.error("Google Maps script failed to load.");
          setIsLoading(false);
        };
        document.body.appendChild(script);
      } else {
        callback();
      }
    };

    // Load Google Maps API script
    loadScript(
      `https://maps.googleapis.com/maps/api/js?key=AIzaSyDqypMXRxstlMdPZ-LUGWb4w36I0ENsu9U&libraries=places`,
      initializeAutocomplete
    );
  }, []);
  // google map end

  const handleStateChange = async (value) => {
    // setIsLoading(true);
    var params = {
      state_name: value,
    };
    await axios
      .post(getApiEndpoint(cheke_state, cheke_state_v2), params)
      .then((res) => {
        // setIsLoading(false);
        const data = res.data;
        if (data.status === 0) {
          setSelectedState({
            name: "",
            state_code: "",
          });
          setSelectedStateCode({
            name: "",
            state_code: "",
          });
          // setAllCitys([]);
          setCity("");
          notifyError(data.message);
        }
        // else {
        //   AllCitys(value);
        // }
      })
      .catch((err) => {
        console.log("err", err);
        // setIsLoading(false);
      });
  };

  const handleStateChange2 = async (value) => {
    // setIsLoading(true);
    var params = {
      state_name: value,
    };
    await axios
      .post(cheke_state, params)
      .then((res) => {
        // setIsLoading(false);
        const data = res.data;
        if (data.status === 0) {
          setSelectedState2({
            name: "",
            state_code: "",
          });
          setSelectedStateCode2({
            name: "",
            state_code: "",
          });
          // setAllCitys([]);
          setCity2("");
          notifyError(data.message);
        }
        // else {
        //   AllCitys(value);
        // }
      })
      .catch((err) => {
        console.log("err", err);
        // setIsLoading(false);
      });
  };

  const AllCitys = async (state) => {
    setIsCityLoading(true);
    await axios
      .post("https://countriesnow.space/api/v0.1/countries/state/cities", {
        country: "United States",
        state: state,
      })
      .then((res) => {
        setIsCityLoading(false);
        const data = res.data.data;
        console.log("citys", res.data.data);
        setAllCitys(data);
      })
      .catch((err) => {
        console.log("err", err);
        setIsCityLoading(false);
      });
  };

  // page 1 validation

  const Page1Validate = () => {
    if (email === "" || email === null) {
      notifyError("Please enter Email Address.");
      return;
    } else if (!validateEmail(email)) {
      notifyError("Please enter a valid Email Address.");
      return;
    } else if (firstName === "" || firstName === null) {
      notifyError("Please enter First Name.");
      return;
    } else if (lastName === "" || lastName === null) {
      notifyError("Please enter Last Name.");
      return;
    } else if (address === "" || address === null) {
      notifyError("Please enter Address.");
      return;
    } else if (address.length > 35) {
      notifyError("Street Address cannot be more than 35 characters.");
      return;
    } else if (
      getselectedStateCode.name === "" ||
      getselectedStateCode.name === null
    ) {
      notifyError("Please select State.");
      return;
    } else if (
      getselectedStateCode.name.toUpperCase() === "LOUISIANA" ||
      getselectedStateCode.name.toUpperCase() === "MISSISSIPPI"
    ) {
      setShowStateRestrictedModal(true);
      return;
    } else if (city === "" || city === null) {
      notifyError("Please select City.");
      return;
      // } else if (getallCitys.includes(city) == false) {
      //   notifyError("Please select City.");
      //   return;
    } else if (postalCode === "" || postalCode === null) {
      notifyError("Please enter Postal Code.");
      return;
    } else if (phoneNumber == "" || phoneNumber == null) {
      notifyError("Please enter Phone Number.");
      return;
    } else if (phoneNumber?.length < 10) {
      notifyError("Please enter valid Phone Number.");
      return;
    } else {
      setSection2(true);
    }
  };

  // page 2 validations

  const Page2Validate = () => {
    if (cardNumber === "" || cardNumber === null) {
      notifyError("Please enter Card Number.");
      return;
    } else if (cardNumber.length < 15 || cardNumber.length > 16) {
      notifyError("Please enter valid Card Number.");
      return;
    } else if (cardholdername === "" || cardholdername === null) {
      notifyError("Please enter Name on Card.");
      return;
    } else if (expiryDate === "" || expiryDate === null) {
      notifyError("Please enter Expiry Date.");
      return;
    } else {
      // Split the expiry date into month and year
      const [month, year] = expiryDate.split("/");

      // Check if the month and year are valid
      if (!month || !year || month.length !== 2 || year.length !== 2) {
        notifyError(
          "Invalid format. Please enter the expiry date in MM/YY format."
        );
        return;
      }

      // Check if the month is valid (between 01 and 12)
      if (parseInt(month, 10) < 1 || parseInt(month, 10) > 12) {
        notifyError("Invalid month. Please enter a valid month (01-12).");
        return;
      }

      // Check if the year is valid (current year or future year)
      const currentYear = new Date().getFullYear() % 100; // Get last 2 digits of current year
      if (parseInt(year, 10) < currentYear) {
        notifyError("Invalid year. Please enter a valid future year.");
        return;
      }
    }
    if (cvv === "" || cvv === null) {
      notifyError("Please enter Security code.");
      return;
    } else if (cvv.length < 3) {
      notifyError("Please enter valid Security code.");
      return;
    } else if (!sameAsShipping && (firstName2 === "" || firstName2 === null)) {
      notifyError("Please enter First Name.");
      return;
    } else if (!sameAsShipping && (lastName2 === "" || lastName2 === null)) {
      notifyError("Please enter Last Name.");
      return;
    } else if (!sameAsShipping && (address2 === "" || address2 === null)) {
      notifyError("Please enter Address.");
      return;
    } else if (!sameAsShipping && address2.length > 35) {
      notifyError("Street Address cannot be more than 35 characters.");
      return;
    } else if (
      !sameAsShipping &&
      (getselectedStateCode2.name === "" || getselectedStateCode2.name === null)
    ) {
      notifyError("Please select State.");
      return;
    } else if (
      !sameAsShipping &&
      (getselectedStateCode2.name.toUpperCase() === "LOUISIANA" ||
        getselectedStateCode2.name.toUpperCase() === "MISSISSIPPI")
    ) {
      setShowStateRestrictedModal(true);
      return;
    } else if (!sameAsShipping && (city2 === "" || city2 === null)) {
      notifyError("Please select City.");
      return;
      // } else if (!sameAsShipping && getallCitys.includes(city2) == false) {
      //   notifyError("Please select City.");
      //   return;
    } else if (
      !sameAsShipping &&
      (postalCode2 === "" || postalCode2 === null)
    ) {
      notifyError("Please enter Postal Code.");
      return;
    } else if (
      !sameAsShipping &&
      (phoneNumber2 === "" || phoneNumber2 === null)
    ) {
      notifyError("Please enter Phone Number.");
      return;
    } else if (!sameAsShipping && phoneNumber2.length < 10) {
      notifyError("Please enter valid Phone Number.");
      return;
    } else {
      checkout_api();
      // console.log("done");
    }
  };
  // Add Facebook Pixel initialization
  useEffect(() => {
    if (window.fbq) {
      window.fbq("track", "InitiateCheckout");
    }
  }, []);

  const checkout_api = async () => {
    // Get URL parameters before try block
    const urlParams = new URLSearchParams(window.location.search);
    const AFFID = urlParams.get("affid") || "";
    const C1 = urlParams.get("c1") || "";
    const C2 = urlParams.get("c2") || "";
    const C3 = urlParams.get("c3") || "";
    try {
      setIsLoading(true);

      const param = {
        email,
        card_type: getcardid,
        card_no: cardNumber,
        ex_month: exMonth,
        ex_year: exYear,
        cvv_no: cvv,
        card_holder_name: cardholdername,
        zip_code: postalCode,
        state_name: getselectedStateCode?.state_code || "",
        first_name: firstName,
        last_name: lastName,
        product_id: id,
        address,
        city_name: city,
        phone: phoneNumber,
        contact_details_id,
        promo_codes: appliedDiscount,
        start_url: window.location.href,
        country: "US",

        billingFirstName: sameAsShipping ? "" : firstName2,
        billingLastName: sameAsShipping ? "" : lastName2,
        billingAddress: sameAsShipping ? "" : address2,
        billingCity: sameAsShipping ? "" : city2,
        billingState: sameAsShipping
          ? ""
          : getselectedStateCode2?.state_code || "",
        billingZip: sameAsShipping ? "" : postalCode2,
        billingCountry: sameAsShipping ? "" : "US",
        billingSameAsShipping: sameAsShipping ? "YES" : "NO",

        // New params from URL
        AFFID: AFFID,
        C1: C1,
        C2: C2,
        C3: C3,
      };

      const response = await axios.post(getApiEndpoint(createOrder_test, createOrder_test_v2), param);
      const data = response?.data;

      setIsLoading(false);

      if (!data) {
        notifyError("Unexpected server response. Please try again.");
        return;
      }

      if (data.status === 1) {
        const collectOrderId = (value, ids) => {
          if (value == null || value === "") return;
          if (typeof value === "object") {
            collectOrderId(value.order_id ?? value.id, ids);
            return;
          }
          String(value)
            .split(",")
            .map((orderId) => orderId.trim())
            .filter(Boolean)
            .forEach((orderId) => {
              if (!ids.includes(orderId)) ids.push(orderId);
            });
        };
        const placedOrderIds = [];
        if (Array.isArray(data.order_ids)) {
          data.order_ids.forEach((orderId) => collectOrderId(orderId, placedOrderIds));
        }
        if (Array.isArray(data.success_orders)) {
          data.success_orders.forEach((order) => collectOrderId(order, placedOrderIds));
        }
        if (placedOrderIds.length === 0) {
          collectOrderId(data.order_id, placedOrderIds);
        }
        const hasOrderList = Array.isArray(data.order_ids) || Array.isArray(data.success_orders);

        if (hasOrderList && placedOrderIds.length === 0) {
          notifyError(data.message || "Order failed. Please try again.");
          return;
        }

        const placedOrderId = placedOrderIds.join(",");
        sessionStorage.setItem("checkout_order_ids", JSON.stringify(placedOrderIds));

        // // Inject Microsoft Clarity script dynamically
        // if (!window.clarity) {
        //   (function (c, l, a, r, i, t, y) {
        //     c[a] = c[a] || function () {
        //       (c[a].q = c[a].q || []).push(arguments);
        //     };
        //     t = l.createElement(r);
        //     t.async = 1;
        //     t.src = "https://www.clarity.ms/tag/s4ycd7olti";
        //     y = l.getElementsByTagName(r)[0];
        //     y.parentNode.insertBefore(t, y);
        //   })(window, document, "clarity", "script", "s4ycd7olti");
        // }

        // Track successful purchase with Facebook Pixel
        const orderProducts = Array.isArray(getdata) ? getdata : null;
        const orderBasePrice = orderProducts ? getproductPrice : getdata.product_price;
        const orderProductName = orderProducts
          ? orderProducts.map((item) => item?.product_name).filter(Boolean).join(", ")
          : getdata?.product_name;
        const orderCategoryName = orderProducts
          ? orderProducts.some((item) => item?.product_category_name === "Weight Loss")
            ? "Weight Loss"
            : orderProducts[0]?.product_category_name
          : getdata.product_category_name;

        if (window.fbq) {
          window.fbq("track", "Purchase", {
            value:
              orderBasePrice != null && !isNaN(orderBasePrice)
                ? discount_percent && discount_percent !== "0.00"
                  ? orderBasePrice -
                  (orderBasePrice *
                    (parseFloat(discount_percent) || 0)) /
                  100
                  : orderBasePrice - (parseFloat(discount_amount) || 0)
                : 0,
            currency: "USD",
            content_ids: [id],
            content_name: orderProductName,
            content_type: "product",
          });
        }

        setorder_id(placedOrderId);

        // Check if product ID is 130-131 and redirect to membership page
        if (id === "130" || id === "131") {
          // Redirect to membership page for product IDs 130-131
          window.location.href = "https://app.coreagerx.com/v2/membership";
        } else {
          // Default redirect to thank you page for other products
          navigate(`/thankyou?order_ids=${encodeURIComponent(placedOrderId)}`, {
            state: {
              order_id: placedOrderId,
              order_ids: placedOrderIds,
              email,
              first_name: firstName,
              last_name: lastName,
              phone_number: phoneNumber,
              state_name: getselectedStateCode?.name || "",
              state_code: getselectedStateCode?.state_code || "",
              address: address,
              city: city,
              postal_code: postalCode,
              total_price:
                orderBasePrice != null && !isNaN(orderBasePrice)
                  ? discount_percent && discount_percent !== "0.00"
                    ? orderBasePrice -
                    (orderBasePrice *
                      (parseFloat(discount_percent) || 0)) /
                    100
                    : orderBasePrice - (parseFloat(discount_amount) || 0)
                  : "",
              product_category_name: orderCategoryName,
              product_name: orderProductName || "",
              unique_id: uniqueId,
            },
          });
        }
      } else if (data.status === 5) {
        setCardDeclinedMessage(data.message || "Your card was declined.");
        setShowCardDeclinedModal(true);
      } else if (data.error_details?.message) {
        notifyError(data.error_details.message);
      } else {
        notifyError(data.message || "Order failed. Please try again.");
      }

      console.log("Order Response =>", data);
    } catch (error) {
      setIsLoading(false);
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong. Please try again.";
      notifyError(message);
      console.error("Checkout API Error:", error);
    }
  };

  const handleCardChange = (event) => {
    const cardValue = parseInt(event.target.value);
    setCardid(cardValue);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    // Only set the CVV if the length is 3 or less and it's numeric
    if (value.length <= 4 && /^\d*$/.test(value)) {
      setCvv(value);
    }
  };

  const formatCardNumber = (cardNumber) => {
    // Add spaces every 4 characters
    return cardNumber.replace(/\D/g, "").replace(/(\d{4})(?=\d)/g, "$1 ");
  };

  const [validEmail, setValidEmail] = useState(true);

  const handleEmailChange = (e) => {
    const input = e.target.value;
    setEmail(input);

    // Basic email validation regex
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isValid = emailRegex.test(input);

    setValidEmail(isValid);
  };

  const productChange = (id) => {
    console.log("e.targate.value", id);
    navigate(`/${id}`);
    FetchProduct(id);
  };

  // everflow pixel start

  // Load Everflow script dynamically
  const loadEverflowScript = () => {
    if (
      !document.querySelector(
        'script[src="https://www.hzbfe8trk.com/scripts/sdk/everflow.js"]'
      )
    ) {
      const script = document.createElement("script");
      script.src = "https://www.hzbfe8trk.com/scripts/sdk/everflow.js";
      script.async = true;
      document.body.appendChild(script);
    }
  };

  // Call EF.click when the component mounts
  // useEffect(() => {
  //   const currentUrl = window.location.href;

  //   // Parse the URL to extract query parameters
  //   const params = new URLSearchParams(new URL(currentUrl).search);

  //   // Get the 'uniqueId' parameter
  //   const click_id = params.get("click_id");
  //   console.log("click_id", click_id);
  //   loadEverflowScript();
  //   window.EF = window.EF || {}; // Ensure EF is available
  //   window.onload = () => {
  //     if (window.EF && window.EF.click) {
  //       window.EF.click({
  //         offer_id: window.EF.urlParameter("oid"),
  //         affiliate_id: window.EF.urlParameter("affid"),
  //         sub1: window.EF.urlParameter("sub1"),
  //         sub2: window.EF.urlParameter("sub2"),
  //         sub3: window.EF.urlParameter("sub3"),
  //         sub4: window.EF.urlParameter("sub4"),
  //         sub5: window.EF.urlParameter("sub5"),
  //         uid: window.EF.urlParameter("uid"),
  //         source_id: window.EF.urlParameter("source_id"),
  //         transaction_id: window.EF.urlParameter("click_id"),
  //       });
  //     }
  //   };
  // }, []);

  // Trigger the conversion when checkout is complete
  // useEffect(() => {
  //   if (getskipModel) {
  //     // loadEverflowScript(); // Load the script dynamically
  //     const timer = setTimeout(() => {
  //       console.log("test data " + email);
  //       console.log("test data " + getorder_id);
  //       if (window.EF && window.EF.conversion) {
  //         window.EF.conversion({
  //           offer_id: 1,

  //           amount:
  //             discount_percent !== "0.00"
  //               ? (
  //                   getproductPrice -
  //                   (getproductPrice * discount_percent) / 100
  //                 ).toFixed(0)
  //               : (getproductPrice - discount_amount).toFixed(0),
  //           email: email,
  //           order_id: getorder_id,
  //         });
  //       } else {
  //         console.error("Everflow SDK not loaded or EF object not available.");
  //       }
  //     }, 500); // Delay to ensure the script has loaded

  //     return () => clearTimeout(timer); // Cleanup the timer
  //   }
  // }, [getskipModel]); // Run effect when checkout is complete

  // everflow pixel end

  // memberportel redire url
  const currentDomain = window.location.hostname;

  let memberPortalUrl = "https://member.coreagerx.com/"; // Default URL

  if (currentDomain === "checkout.coreagerx.com") {
    memberPortalUrl = "https://member.coreagerx.com/";
  } else if (currentDomain === "checkoutdev-coreagerx.wlmd.dev") {
    memberPortalUrl = "https://mpdev-coreagerx.wlmd.dev/";
  }

  console.log("currentDomain", currentDomain);
  console.log("memberPortalUrl", memberPortalUrl);

  // const targetUrl = getdata.product_category_name === "Weight Loss"
  //   ? `https://coreagerx.com/onboarding/?order_id=${getorder_id}&unique_id=${uniqueId}&op=intake`
  //   : memberPortalUrl;

  const targetUrl = memberPortalUrl;

  // useEffect for close modal after 3 secound
  useEffect(() => {
    if (getskipModel) {
      // loadEverflowScript(); // Load the script dynamically
      const timer = setTimeout(() => {
        setSkipModel(false);
        window.location.assign(targetUrl);
      }, 3000); // Delay to ensure the script has loaded

      return () => clearTimeout(timer); // Cleanup the timer
    }
  }, [getskipModel]);

  // after email api
  const chargeblastScriptPromiseRef = useRef(null);

  const handleEmailBlur = async () => {
    console.log("Chargeblast call api start");
    
    const trimmedEmail = email.trim();
    
    // Re-validate email on blur
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isValid = emailRegex.test(trimmedEmail);
    setValidEmail(isValid);

    if (!isValid || trimmedEmail === "") {
      console.log("Email validation failed or empty, skipping Chargeblast call");
      return;
    }

    setIsEmailLoading(true);

    // Wait for Chargeblast script to be ready (script is deferred in index.html)
    const waitForChargeblast = () => {
      if (chargeblastScriptPromiseRef.current) {
        return chargeblastScriptPromiseRef.current;
      }

      chargeblastScriptPromiseRef.current = new Promise((resolve, reject) => {
        // If already available, resolve immediately
        if (window.Chargeblast && typeof window.Chargeblast.identify === "function") {
          console.log("Chargeblast already available");
          resolve(window.Chargeblast);
          return;
        }

        // Check if script exists in head
        const script = document.getElementById("chargeblast-script");
        if (!script) {
          reject(new Error("Chargeblast script tag not found in head"));
          return;
        }

        // Poll for Chargeblast to become available
        let attempts = 0;
        const maxAttempts = 100; // 10 seconds max
        const checkInterval = setInterval(() => {
          attempts++;
          if (window.Chargeblast && typeof window.Chargeblast.identify === "function") {
            clearInterval(checkInterval);
            console.log("Chargeblast ready after polling");
            resolve(window.Chargeblast);
          } else if (attempts >= maxAttempts) {
            clearInterval(checkInterval);
            reject(new Error("Chargeblast not available after waiting"));
          }
        }, 100);

        // Also check on script load event
        if (script.readyState === "complete" || script.readyState === "loaded") {
          // Script already loaded, start polling immediately
        } else {
          script.onload = () => {
            // Script loaded, start polling
          };
          script.onerror = (err) => {
            clearInterval(checkInterval);
            reject(err);
          };
        }
      });

      return chargeblastScriptPromiseRef.current;
    };

    // Call Chargeblast identify
    try {
      const chargeblast = await waitForChargeblast();
      if (chargeblast && typeof chargeblast.identify === "function") {
        console.log("Chargeblast identify called with:", trimmedEmail);
        chargeblast.identify(trimmedEmail);
      }
    } catch (err) {
      console.error("Chargeblast identify failed:", err);
    }

    // Call member view API
    try {
      const response = await axios.post(getApiEndpoint(member_view, member_view_v2), {
        email: trimmedEmail,
        product_id: id,
        // campaign_id: getcampaignID
      });
      console.log("API Response:", response.data);
      if (response.data.status === 1) {
        setProductPrice(response.data?.m_price);
      }
    } catch (error) {
      console.error("Error sending email:", error);
    } finally {
      setIsEmailLoading(false);
    }
  };

  // Auto-apply coupon for Weight Loss products (check URL first, then fallback to SUMMER150)
  useEffect(() => {
    if (
      isWeightLossCheckout &&
      !appliedDiscount &&
      !couponManuallyRemoved &&
      !discountCode && // Only auto-apply if no discount code is currently entered
      !summer150AutoApplied // Only auto-apply once
    ) {
      // Check if there's a coupon in the URL
      const urlParams = new URLSearchParams(window.location.search);
      const urlCoupon = urlParams.get("coupon");

      let couponToApply = "SUMMER150"; // Default fallback

      if (urlCoupon) {
        // Use the coupon from URL if available
        couponToApply = urlCoupon;
        console.log("Applying coupon from URL:", urlCoupon);
      } else {
        console.log("No URL coupon found, applying default SUMMER150");
      }

      // Auto-fill the discount code
      setDiscountCode(couponToApply);
      setSummer150AutoApplied(true); // Mark as auto-applied

      // Auto-apply the coupon with the correct value
      const timer = setTimeout(() => {
        handleApplyDiscount(couponToApply);
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [isWeightLossCheckout]); // Only depend on product category, not on appliedDiscount

  // Clear error when discount code is cleared
  useEffect(() => {
    if (!discountCode && error) {
      setError("");
    }
  }, [discountCode, error]);

  if (isloading) {
    return (
      <div style={{ height: "97vh" }}>
        <Loading />
      </div>
    );
  }

  return (
    <>
      {/* <Navbar2 color="#fff" logo={images.logo} /> */}
      <div className="payment-container" style={{ position: "relative" }}>
        {/* <div className="payment-content">
          <div className="payment-header_p">
            <p className="paymen_p_tag">Checkout</p>
          </div>
        </div> */}
        <div className="payment-content2 payment-column-reverse">
          {/* onSubmit={handleSubmit} */}
          <div className="checkout-form-wrapp">
            <div className="checkout_logo_wrapp headline_for_mob2">
              <img src={images.logo} className="" alt="" />
              <div className="checkout_head_name_wrapp">
                <p>Shipping</p>
                <FiChevronRight size={20} style={{ display: "block" }} />
                <p>Payment</p>
              </div>
            </div>

            {!getsection2 ? (
              <div className="checkout-form">
                {/* contect info */}
                <h3 style={{marginTop: "5px", marginBottom: "5px", width: "100%", color: "#000", fontWeight: "400"}}>Contact</h3>
                <div className="form-group">
                  <input
                    type="email"
                    placeholder={
                      isemailLoading ? "Verifying..." : "Email Address"
                    }
                    value={email}
                    onChange={handleEmailChange}
                    onBlur={handleEmailBlur} // Call API when moving away
                    style={{
                      border: validEmail ? "" : "1px solid red",
                      backgroundColor: isemailLoading ? "#f5f5f5" : "white", // Light gray when verifying
                      color: isemailLoading ? "#888" : "black",
                      cursor: isemailLoading ? "not-allowed" : "text",
                    }}
                    disabled={isemailLoading}
                  />
                  {isemailLoading && (
                    <p style={{ color: "blue", fontSize: "12px" }}>
                      Verifying...
                    </p>
                  )}
                  {!validEmail && (
                    <p style={{ color: "red", marginTop: "2px" }}>
                      Please enter a valid email address.
                    </p>
                  )}
                </div>
                <div className="form-group-inline">
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="First Name"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Last Name"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                  </div>
                </div>
                <h3 style={{marginTop: "5px", marginBottom: "5px", width: "100%", color: "#000", fontWeight: "400"}}>Shipping Address</h3>
                {/* <div className="form-group"> */}
                {/* <select
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                >
                  <option>United States</option>
                </select> */}
                {/* </div> */}
               
                <div className="form-group">
                  <input
                    ref={inputRef1}
                    type="text"
                    placeholder="Street Address"
                    value={address}
                    maxLength={35}
                    // onChange={(e) => setAddress(e.target.value)}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      if (inputValue.length > 35) {
                        notifyError("Street Address cannot be more than 35 characters.");
                        return;
                      }
                      if (inputValue.length == 0) {
                        setSelectedState({
                          name: "",
                          state_code: "",
                        });
                        setSelectedStateCode({
                          name: "",
                          state_code: "",
                        });
                        setCity("");
                        setPostalCode("");
                        setStateError("");
                      }
                      setAddress(inputValue);
                    }}
                  />
                </div>
                <p style={{marginTop: "-1px", marginBottom: "13px", width: "100%",fontWeight: "300", color: "gray", fontSize: "14px" }}>Start typing to see address suggestions • We cannot ship to PO boxes</p>

                <div className="form-group-inline">
                  <div className="inline_seond">
                    <select
                      value={JSON.stringify({
                        name: getselectedState.name,
                        state_code: getselectedState.state_code,
                      })}
                      onChange={(e) => {
                        const selectedState = JSON.parse(e.target.value);

                        console.log("getselectedStateCode1", selectedState);

                        // Check if state is Louisiana or Mississippi
                        const restrictedStates = ["LOUISIANA", "MISSISSIPPI"];
                        if (restrictedStates.includes(selectedState.name.toUpperCase())) {
                          setShowStateRestrictedModal(true);
                          setSelectedState({
                            name: "",
                            state_code: "",
                          });
                          setSelectedStateCode({
                            name: "",
                            state_code: "",
                          });
                          return;
                        }

                        // Clear error if valid state selected
                        setStateError("");
                        setSelectedState({
                          name: selectedState.name,
                          state_code: selectedState.state_code,
                        });
                        setSelectedStateCode({
                          name: selectedState.name,
                          state_code: selectedState.state_code,
                        });
                        // setSelectedStateCode(selectedState.state_code);
                        handleStateChange(selectedState.name); // Optional: If you have additional logic
                        console.log(
                          "getselectedStateCode",
                          selectedState.state_code
                        );
                      }}
                    >
                      <option
                        value={JSON.stringify({ name: "", state_code: "" })}
                      >
                        Select state
                      </option>
                      {getstate.map((state) => (
                        <option
                          key={state.state_code}
                          value={JSON.stringify({
                            name: state.name,
                            state_code: state.state_code,
                          })}
                        >
                          {state.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="inline_seond">
                    {iscityloading ? (
                      <div
                        style={{
                          marginTop: "10px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginBottom: "1rem",
                        }}
                      >
                        <div
                          style={{
                            width: "20px",
                            height: "20px",
                            border: "3px solid #e0e0e0",
                            borderTop: "3px solid #f39322",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite",
                          }}
                        ></div>
                      </div>
                    ) : (
                      // <select
                      //   value={city} // Use city directly
                      //   onChange={(e) => {
                      //     setCity(e.target.value);
                      //     setPostalCode("");
                      //   }} // Update city state on selection
                      //   disabled={iscityloading}
                      // >
                      //   <option value="">Select city</option>
                      //   {getallCitys.map((city, index) => (
                      //     <option key={index} value={city}>
                      //       {city}
                      //     </option>
                      //   ))}
                      // </select>
                      <div className="form-group" style={{ width: "100%" }}>
                        <input
                          type="text"
                          placeholder="City"
                          value={city}
                          // onChange={(e) => setFirstName(e.target.value)}
                          onChange={(e) => {
                            setCity(e.target.value);
                            setPostalCode("");
                          }}
                        />
                      </div>
                    )}
                  </div>
                  

                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Postal Code"
                      value={postalCode}
                      onChange={(e) => setPostalCode(e.target.value)}
                    />
                  </div>
                </div>
                {/* <br /> */}
                {stateError && (
                    <p style={{ color: "red", fontSize: "12px", marginTop: "5px", marginLeft: "5px", marginBottom: "10px", width: "100%" }}>
                      {stateError}
                    </p>
                  )}
                {/* phone number start */}
                <div className="form-group">
                  <input
                    type="text"
                    placeholder="Phone number"
                    value={phoneNumber}
                    onChange={(e) => {
                      const input = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                      if (input.length <= 10) {
                        setPhoneNumber(input);
                      }
                    }}
                  />
                </div>
                {/* phone number end */}
                {/* <p>All transactions are secure and encrypted.</p> */}
                <br />
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  <input
                    type="checkbox"
                    id="medicationConsent"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                    style={{
                      marginTop: "3px",
                      marginRight: "10px",
                      width: "10px",
                      height: "10px",
                      padding: "5px",
                      cursor: "pointer",
                      appearance: "auto",
                      accentColor: "black",
                    }}
                  // className="details_of_checkbox"
                  />
                  <label
                    htmlFor="medicationConsent"
                    style={{
                      fontSize: "14px",
                      lineHeight: "1.5",
                      fontWeight: "300",
                    }}
                  >
                    <strong>Text me when my medication ships</strong> and for
                    exclusive health and weight loss content. I agree to receive
                    marketing text messages from coreagerx at the number
                    provided above. Consent is not a condition of purchase.
                    Message & data rates may apply.
                  </label>
                </div>
                {/* Submit btn start */}
                <br />
                {/* Submit btn end */}
                {/* promo code start*/}
                {/* <div className="payment_card">
              <div className="payment_card_titel">
                <b>
                  <RiDiscountPercentLine />
                  Promo Code
                </b>
              </div>

              <div className="form-group-inline">
                <div
                  className="inline_seond promo_input"
                >
                  <input
                    type="text"
                    value={discountCode}
                    onChange={(e) => setDiscountCode(e.target.value)}
                    placeholder="Enter Promo Code"
                  />
                </div>
                <div
                  className="inline_seond"
                  style={{ width: "30%", minWidth: "100px" }}
                >
                  <button className="btn" onClick={handleApplyDiscount}>
                    Apply
                  </button>
                </div>
              </div>
            </div> */}
                {/* Display error message */}

                {/* promo code end */}
                <br />
                {/* <br /> */}
                {/* payment details */}
                {/* <div className="payment_card">
              <div className="payment_card_titel">
                <b>
                  <MdOutlinePayment />
                  Payment Methods
                </b>
                <div className="card_icon_div">
                  <img
                    src={images.visa}
                    className="item_img_card"
                    alt="Headphones"
                  />
                  <img
                    src={images.master}
                    className="item_img_card"
                    alt="Headphones"
                  />
                  <img
                    src={images.jcb}
                    className="item_img_card"
                    alt="Headphones"
                  />
                  <img
                    src={images.american}
                    className="item_img_card"
                    alt="Headphones"
                  />
                </div>
              </div>
              <div className="details-card">
                <div className="form-group">
                  <select
                    className="card-dropdown"
                    onChange={handleCardChange}
                    value={getcardid}
                  >
                    <option value={1}>Visa</option>
                    <option value={2}>MasterCard</option>
                    <option value={3}>Discover</option>
                    <option value={4}>American Express</option>
                  </select>
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    placeholder="Card holder name"
                    className="card-number"
                    value={cardholdername}
                    onChange={(e) => setcardholdername(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    placeholder="Card Number"
                    className="card-number"
                    value={formatCardNumber(cardNumber)}
                    onChange={(e) => {
                      const input = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                      if (input.length <= 16) {
                        setCardNumber(input);
                      }
                    }}
                  />
                </div>
                <div className="form-group-inline">
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="MM/YY"
                      className="expiry-date"
                      value={expiryDate}
                      onChange={(e) => {
                        let input = e.target.value;
                        // Remove non-numeric characters except "/"
                        input = input.replace(/\D/g, "");

                        // Ensure input is limited to 4 characters (MMYY format)
                        if (input.length > 4) {
                          input = input.slice(0, 4);
                        }

                        // Extract MM and YY
                        const month = input.slice(0, 2);
                        const year = input.slice(2, 4);

                        // Update state for ex_month and ex_year
                        setExMonth(month);
                        setExYear(year);

                        // Format input to display MM/YY in the input field
                        setExpiryDate(
                          month + (year.length > 0 ? "/" + year : "")
                        );
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="CVV"
                      className="cvv"
                      value={cvv}
                      onChange={handleChange}
                      maxLength={3}
                    />
                  </div>
                </div>
                <div className="note_titel_">
                
                </div>
                <center>
                  <button className="btn-checkout" onClick={checkout_api}>
                    Complete Checkout
                  </button>
                </center>
              </div>
            </div> */}
                {/* continue to payment btn start */}
                <button className="btn2" onClick={Page1Validate}>
                  Continue to payment
                </button>
                {/* continue to payment btn end */}

                {/* Payment Security Section */}
                <div className="payment-security-section">
                  <div className="security-header">
                    <img
                      src={images.lock}
                      alt="lock"
                      style={{ width: "20px", height: "20px" }}
                    />
                    <p>Guaranteed safe & secure checkout</p>
                  </div>
                  <div className="payment-methods">
                    <img src={images.visa} alt="VISA" />
                    <img src={images.master} alt="Mastercard" />
                    <img src={images.american} alt="AMEX" />
                    <img src={images.jcb} alt="jcb" />
                    <img src={images.discover} alt="DISCOVER" />
                    <img src={images.pay_img} alt="pay_img" />
                    <img src={images.unionpay} alt="UnionPay" />
                  </div>
                </div>

                {/* Customer Reviews Section */}
                <div className="customer-reviews-section">
                  <h3 className="reviews-title">Customer Reviews</h3>

                  <div className="review-item">
                    <blockquote className="review-text">
                      "Finally, a clinic that doesn’t trap you in subscriptions. Got my GLP-1 approved and shipped fast. The price was exactly what they said, no upsells or surprise billing."
                    </blockquote>
                    <div className="review-meta">
                      <div className="star-rating">
                        <img
                          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fbbf24'%3E%3Cpath d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/%3E%3C/svg%3E"
                          alt="star"
                          className="star"
                        />
                        <img
                          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fbbf24'%3E%3Cpath d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/%3E%3C/svg%3E"
                          alt="star"
                          className="star"
                        />
                        <img
                          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fbbf24'%3E%3Cpath d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/%3E%3C/svg%3E"
                          alt="star"
                          className="star"
                        />
                        <img
                          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fbbf24'%3E%3Cpath d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/%3E%3C/svg%3E"
                          alt="star"
                          className="star"
                        />
                        <img
                          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fbbf24'%3E%3Cpath d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/%3E%3C/svg%3E"
                          alt="star"
                          className="star"
                        />
                      </div>
                      <span className="reviewer-info">Cindy P., 55</span>
                    </div>
                  </div>

                  <div className="review-item">
                    <blockquote className="review-text">
                      "I’ve been with CoreAgeRx for months and my dosage has increased twice - the price never changed. Most places raise prices as you go up, but here it stays the same for every refill. Love that transparency.”
                    </blockquote>
                    <div className="review-meta">
                      <div className="star-rating">
                        <img
                          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fbbf24'%3E%3Cpath d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/%3E%3C/svg%3E"
                          alt="star"
                          className="star"
                        />
                        <img
                          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fbbf24'%3E%3Cpath d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/%3E%3C/svg%3E"
                          alt="star"
                          className="star"
                        />
                        <img
                          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fbbf24'%3E%3Cpath d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/%3E%3C/svg%3E"
                          alt="star"
                          className="star"
                        />
                        <img
                          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fbbf24'%3E%3Cpath d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/%3E%3C/svg%3E"
                          alt="star"
                          className="star"
                        />
                        <img
                          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fbbf24'%3E%3Cpath d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/%3E%3C/svg%3E"
                          alt="star"
                          className="star"
                        />
                        <img
                          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fbbf24'%3E%3Cpath d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/%3E%3C/svg%3E"
                          alt="star"
                          className="star"
                        />
                        <img
                          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fbbf24'%3E%3Cpath d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/%3E%3C/svg%3E"
                          alt="star"
                          className="star"
                        />
                      </div>
                      <span className="reviewer-info">Amanda L. 51</span>
                    </div>
                  </div>

                  <div className="review-item">
                    <blockquote className="review-text">
                      "The process was seamless—no doctor visits, no pharmacy
                      lines. I had my meds and support within days."
                    </blockquote>
                    <div className="review-meta">
                      <div className="star-rating">
                        <img
                          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fbbf24'%3E%3Cpath d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/%3E%3C/svg%3E"
                          alt="star"
                          className="star"
                        />
                        <img
                          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fbbf24'%3E%3Cpath d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/%3E%3C/svg%3E"
                          alt="star"
                          className="star"
                        />
                        <img
                          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fbbf24'%3E%3Cpath d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/%3E%3C/svg%3E"
                          alt="star"
                          className="star"
                        />
                        <img
                          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fbbf24'%3E%3Cpath d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/%3E%3C/svg%3E"
                          alt="star"
                          className="star"
                        />
                        <img
                          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fbbf24'%3E%3Cpath d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/%3E%3C/svg%3E"
                          alt="star"
                          className="star"
                        />
                      </div>
                      <span className="reviewer-info">Daniel M., 36</span>
                    </div>
                  </div>


                </div>
              </div>
            ) : (
              <div className="checkout-form">
                {/* contect box start */}
                <div className="sec2_checkout_box_wrapp">
                  <div>
                    <p>Contact</p>
                    <p>{email}</p>
                    <button
                      onClick={() => {
                        setSection2(false);
                      }}
                    >
                      Change
                    </button>
                  </div>
                  <div style={{ borderBottom: "none" }}>
                    <p>Ship to</p>
                    <p>{address}</p>
                    <button
                      onClick={() => {
                        setSection2(false);
                      }}
                    >
                      Change
                    </button>
                  </div>
                  {/* <div style={{borderBottom:"none"}}>
                    <p>Shipping method</p>
                    <p>Standard</p>
                    <button
                      onClick={() => {
                        setSection2(false);
                      }}
                    >
                      Change
                    </button>
                  </div> */}
                </div>
                {/* contect box end */}
                <br />

                {/* payment box start */}
                <p className="pg2_heading">Payment</p>
                <p className="pg2_des">
                  All transactions are secure and encrypted.
                </p>
                <div className="paymentbox_main_wrapp">
                  <div className="paymentbox_header">
                    <p className="pg2_heading">Credit card</p>
                    <div className="card_icon_div">
                      <img
                        src={images.visa}
                        className="item_img_card"
                        alt="Headphones"
                      />
                      <img
                        src={images.master}
                        className="item_img_card"
                        alt="Headphones"
                      />
                      <img
                        src={images.jcb}
                        className="item_img_card"
                        alt="Headphones"
                      />
                      <img
                        src={images.american}
                        className="item_img_card"
                        alt="Headphones"
                      />
                    </div>
                  </div>
                  <div className="paymentbox_contain">
                    <div className="form-group">
                      <input
                        type="text"
                        placeholder="Card number"
                        className="card-number"
                        value={formatCardNumber(cardNumber)}
                        onChange={(e) => {
                          const input = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                          if (input.length <= 16) {
                            setCardNumber(input);
                          }
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="text"
                        placeholder="Name on card"
                        className="card-number"
                        value={cardholdername}
                        onChange={(e) => setcardholdername(e.target.value)}
                      />
                    </div>
                    <div className="form-group-inline">
                      <div className="form-group">
                        <input
                          type="text"
                          placeholder="Expiration date (MM/YY)"
                          className="expiry-date"
                          value={expiryDate}
                          onChange={(e) => {
                            let input = e.target.value;
                            // Remove non-numeric characters except "/"
                            input = input.replace(/\D/g, "");

                            // Ensure input is limited to 4 characters (MMYY format)
                            if (input.length > 4) {
                              input = input.slice(0, 4);
                            }

                            // Extract MM and YY
                            const month = input.slice(0, 2);
                            const year = input.slice(2, 4);

                            // Update state for ex_month and ex_year
                            setExMonth(month);
                            setExYear(year);

                            // Format input to display MM/YY in the input field
                            setExpiryDate(
                              month + (year.length > 0 ? "/" + year : "")
                            );
                          }}
                        />
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          placeholder="Security code"
                          className="cvv"
                          value={cvv}
                          onChange={handleChange}
                          maxLength={4}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* payment box end */}
                <br />
                {/* billing address start */}

                <p className="pg2_heading">Billing address</p>
                <p className="pg2_des">
                  Select the address that matches your card or payment method.
                </p>

                <div className="paymentbox_main_wrapp">
                  <div className="addressbox_header">
                    <input
                      type="radio"
                      name="addressOption"
                      value="same"
                      checked={sameAsShipping}
                      onChange={() => setSameAsShipping(true)}
                      className="address_box_radio"
                    />
                    <p className="pg2_heading">Same as shipping address</p>
                  </div>
                  <div className="addressbox_header">
                    <input
                      type="radio"
                      name="addressOption"
                      value="different"
                      checked={!sameAsShipping}
                      onChange={() => setSameAsShipping(false)}
                      className="address_box_radio"
                    />
                    <p className="pg2_heading">
                      Use a different billing address
                    </p>
                  </div>
                  {/* Billing Address Form (conditionally rendered) */}
                  {!sameAsShipping && (
                    <div className="paymentbox_contain">
                      <select
                        value={country2}
                        onChange={(e) => setCountry2(e.target.value)}
                      >
                        <option>United States</option>
                        {/* Add more country options here */}
                      </select>
                      <div className="form-group-inline">
                        <div className="form-group">
                          <input
                            type="text"
                            placeholder="First Name"
                            value={firstName2}
                            onChange={(e) => setFirstName2(e.target.value)}
                          />
                        </div>
                        <div className="form-group">
                          <input
                            type="text"
                            placeholder="Last Name"
                            value={lastName2}
                            onChange={(e) => setLastName2(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <input
                          ref={inputRef2}
                          type="text"
                          placeholder="Address"
                          value={address2}
                          maxLength={35}
                          // onChange={(e) => setAddress2(e.target.value)}
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length > 35) {
                              notifyError("Street Address cannot be more than 35 characters.");
                              return;
                            }
                            if (inputValue.length == 0) {
                              setSelectedState2({
                                name: "",
                                state_code: "",
                              });
                              setSelectedStateCode2({
                                name: "",
                                state_code: "",
                              });
                              setCity2("");
                              setPostalCode2("");
                              setStateError2("");
                            }
                            setAddress2(inputValue);
                          }}
                        />
                      </div>
                      <div className="form-group-inline">
                        <div className="inline_seond">
                          <select
                            value={JSON.stringify({
                              name: getselectedState2.name,
                              state_code: getselectedState2.state_code,
                            })}
                            onChange={(e) => {
                              console.log("getselectedStateCode-----", e);
                              const selectedState = JSON.parse(e.target.value);
                              
                              // Check if state is Louisiana or Mississippi
                              const restrictedStates = ["LOUISIANA", "MISSISSIPPI"];
                              if (restrictedStates.includes(selectedState.name.toUpperCase())) {
                                setShowStateRestrictedModal(true);
                                setSelectedState2({
                                  name: "",
                                  state_code: "",
                                });
                                setSelectedStateCode2({
                                  name: "",
                                  state_code: "",
                                });
                                return;
                              }

                              // Clear error if valid state selected
                              setStateError2("");
                              // setSelectedState2(selectedState.name);
                              // setSelectedStateCode2(selectedState.state_code);
                              setSelectedState2({
                                name: selectedState.name,
                                state_code: selectedState.state_code,
                              });
                              setSelectedStateCode2({
                                name: selectedState.name,
                                state_code: selectedState.state_code,
                              });
                              handleStateChange2(selectedState.name);
                              console.log(
                                "getselectedStateCode111",
                                getselectedStateCode
                              );
                            }}
                          >
                            <option
                              value={JSON.stringify({
                                name: "",
                                state_code: "",
                              })}
                            >
                              Select state
                            </option>{" "}
                            {getstate &&
                              getstate.map((states, index) => {
                                return (
                                  <option
                                    value={JSON.stringify({
                                      name: states.name,
                                      state_code: states.state_code,
                                    })}
                                  >
                                    {states.name}
                                  </option>
                                );
                              })}
                            {/* Add more state options here */}
                          </select>
                        </div>
                        <div className="inline_seond">
                          {iscityloading ? (
                            <div
                              style={{
                                marginTop: "10px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginBottom: "1rem",
                              }}
                            >
                              <div
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  border: "3px solid #e0e0e0",
                                  borderTop: "3px solid #f39322",
                                  borderRadius: "50%",
                                  animation: "spin 1s linear infinite",
                                }}
                              ></div>
                            </div>
                          ) : (
                            // <select
                            //   value={city2}
                            //   onChange={(e) => {
                            //     setCity2(e.target.value);
                            //     setPostalCode2("");
                            //   }}
                            // >
                            //   <option value={""}>Select city</option>

                            //   {getallCitys.map((city, index) => {
                            //     return <option value={city}>{city}</option>;
                            //   })}
                            //   {/* Add more state options here */}
                            // </select>
                            <div
                              className="form-group"
                              style={{ width: "100%" }}
                            >
                              <input
                                type="text"
                                placeholder="City"
                                value={city2}
                                onChange={(e) => {
                                  setCity2(e.target.value);
                                  setPostalCode2("");
                                }}
                              />
                            </div>
                          )}
                        </div>

                        <div className="inline_seond">
                          <input
                            type="text"
                            placeholder="Postal Code"
                            value={postalCode2}
                            onChange={(e) => setPostalCode2(e.target.value)}
                          />
                        </div>
                      </div>
                      {stateError2 && (
                        <p style={{ color: "red", fontSize: "12px", marginTop: "5px", marginBottom: 0, width: "100%" }}>
                          {stateError2}
                        </p>
                      )}
                      <div className="form-group">
                        <input
                          type="text"
                          placeholder="Phone number"
                          value={phoneNumber2}
                          onChange={(e) => {
                            const input = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                            if (input.length <= 10) {
                              setPhoneNumber2(input);
                            }
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="features">
                  <ul style={{}}>
                    <li style={{ fontSize: "14px" }}>
                      Free online medical consultation.
                    </li>
                    <li style={{ fontSize: "14px" }}>
                      24/7 support via email or phone.
                    </li>
                    <li style={{ fontSize: "14px" }}>
                      100% refund if you are not prescribed.
                    </li>
                  </ul>
                </div>
                <br />
                <button className="btn2" onClick={Page2Validate}>
                  CHECKOUT NOW
                </button>
                <center>
                  <div className="ssl-secured-payment">
                    <FaLock />
                    <p
                      style={{
                        marginLeft: "5px",
                        fontSize: "16px",
                        color: "#212529",
                        fontWeight: "400",
                      }}
                    >
                      SSL SECURED PAYMENT
                    </p>
                  </div>
                  <div>
                    <p
                      style={{
                        marginLeft: "5px",
                        fontSize: "16px",
                        color: "#212529",
                        fontWeight: "400",
                      }}
                    >
                      {" "}
                      Your information is protected by 256-bit SSL encryption
                    </p>
                  </div>
                </center>
              </div>
            )}
          </div>
          <div className="center_line"></div>
          <div className="order-summary2">
            <div className="checkout_logo_wrapp headline_for_mob">
              <img src={images.logo} className="" alt="" />

              <div className="checkout_head_name_wrapp">
                <p>Shipping</p>
                <FiChevronRight size={20} style={{ display: "block" }} />
                <p>Payment</p>
              </div>
            </div>
            {/* product-info-right details start */}
            <div className={`product-info-right${isMultiProduct ? " product-info-multi" : ""}`}>
              {isMultiProduct &&
                checkoutProducts.map((product, index) => {
                  const productMonths = getMonthsForProduct(product);
                  const imageSrc = product?.product_description?.includes("BM:4")
                    ? images.three_months
                    : product?.product_img?.length > 0
                      ? product.product_img[0]?.img_video
                      : images.bottel_img;
                  return (
                    <div
                      className="product-main-container"
                      key={product?.product_id || index}
                    >
                      <div className="product-image-section">
                        <div className="product-image-container">
                          <div className="product-image">
                            <img
                              src={imageSrc}
                              alt={product?.product_name || "product-img"}
                            />
                          </div>
                          <div className="product-badge">1</div>
                        </div>
                      </div>
                      <div className="product-content-section">
                        <div className="product-details">
                          <h4 className="product-name">{product?.product_name}</h4>
                          <div className="product-price">
                            {(() => {
                              const couponAmount = getProductCouponAmount(product);
                              const linePrice = Math.max(
                                0,
                                parseNumber(product?.product_price) - couponAmount
                              );
                              return (
                                <>
                                  {couponAmount > 0 && (
                                    <span className="original-price">
                                      ${product?.product_price}
                                    </span>
                                  )}
                                  <span className="discounted-price">
                                    ${couponAmount > 0 ? linePrice.toFixed(2) : product?.product_price}
                                    {productMonths > 1 && ` for ${productMonths} months`}
                                  </span>
                                  {productMonths > 1 && (
                                    <span className="monthly-info">
                                      ${((couponAmount > 0 ? linePrice : parseNumber(product?.product_price)) / productMonths).toFixed(2)}
                                      /month
                                    </span>
                                  )}
                                </>
                              );
                            })()}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              {!isMultiProduct && (
              <div className="product-main-container">
                {/* First part - Image with badge */}
                <div className="product-image-section">
                  <div className="product-image-container">
                    <div className="product-image">
                      {getdata?.product_description &&
                        getdata.product_description.includes("BM:4") ? (
                        <img src={images.three_months} alt="3-month supply" />
                      ) : getdata.product_img &&
                        getdata.product_img.length > 0 ? (
                        <img
                          src={
                            getdata?.product_img &&
                              getdata.product_img.length > 0
                              ? getdata.product_img[0]?.img_video
                              : null
                          }
                          alt="product-img"
                        />
                      ) : (
                        <img src={images.bottel_img} alt="product-img" />
                      )}
                    </div>
                    <div className="product-badge">1</div>
                  </div>
                </div>

                {/* Second part - Name and price */}
                <div className="product-content-section">
                  <div className="product-details">
                    <h4 className="product-name">{getdata?.product_name}</h4>

                    {/* Pricing section start */}
                    <div className="product-price">
                      {getdata?.product_category_name === "Weight Loss" ? (
                        // Full pricing for Weight Loss products
                        <>
                          {isDiscountApplied() ? (
                            <>
                              <span className="original-price">
                                ${getdata?.product_price || getproductPrice}
                              </span>
                              <span className="discounted-price">
                                $
                                {calculateDiscountedPrice(getproductPrice).toFixed(2)}
                                {months > 1 && ` for ${months} months`}
                              </span>
                              {/* Show monthly pricing for BM:4 products */}
                              {months > 1 && (
                                <span className="monthly-info">
                                  ${(calculateDiscountedPrice(getproductPrice) / months).toFixed(2)}
                                  /month
                                </span>
                              )}
                            </>
                          ) : (
                            <>
                              <span className="discounted-price">
                                ${getproductPrice}
                                {months > 1 && ` for ${months} months`}
                              </span>
                              {/* Show monthly pricing for BM:4 products without discount */}
                              {months > 1 && (
                                <span className="monthly-info">
                                  ${(getproductPrice / months).toFixed(2)}/month
                                </span>
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        // Simple price for other products
                        <>
                          <span className="discounted-price">
                            ${getproductPrice}
                            {months > 1 && ` for ${months} months`}
                          </span>
                          {/* Show monthly pricing for BM:4 products in other categories */}
                          {months > 1 && (
                            <span className="monthly-info">
                              ${(getproductPrice / months).toFixed(2)}/month
                            </span>
                          )}
                        </>
                      )}
                    </div>
                    {/* Pricing section end */}
                  </div>
                </div>
              </div>
              )}
            </div>
            {/* product-info-right details end */}
            {/* Discount Code start */}
            <div className="discount-code-section">
              <input
                style={{ width: "75%" }}
                type="text"
                placeholder="Discount Code"
                className="input-field"
                value={discountCode || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  console.log("Input onChange:", { value, type: typeof value });
                  // Clear error when user starts typing
                  if (error) {
                    setError("");
                  }
                  // Ensure we always set a string value
                  if (typeof value === "string") {
                    setDiscountCode(value);
                  } else {
                    console.error(
                      "Invalid input value type:",
                      typeof value,
                      value
                    );
                    setDiscountCode("");
                  }
                }}
                onFocus={() => {
                  // Clear error when input is focused
                  if (error) {
                    setError("");
                  }
                }}
              />
              <button
                style={{ width: "25%" }}
                onClick={() => {
                  console.log("Button clicked, discountCode:", {
                    discountCode,
                    type: typeof discountCode,
                  });
                  handleApplyDiscount();
                }}
                className="apply-button"
                disabled={
                  !discountCode ||
                  typeof discountCode !== "string" ||
                  !discountCode.trim()
                }
              >
                <p style={{ color: "white" }}>Apply</p>
              </button>
            </div>
            {/* Discount Code end */}
            {/* Display error message */}
            {error && (
              <p style={{ color: "red", marginTop: "10px" }}>{error}</p>
            )}
            {applyLoading && (
              <div
                style={{
                  marginTop: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    border: "3px solid #e0e0e0",
                    borderTop: "3px solid var(--clr-main)",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                  }}
                ></div>
              </div>
            )}
            {/* Display discount badge on success */}
            {appliedDiscount && (
              <div
                style={{
                  marginTop: "10px",
                  backgroundColor: "#e0f7fa",
                  padding: "5px 10px",
                  display: "inline-block",
                  borderRadius: "5px",
                  width: "fit-content",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span style={{ color: "#00796b" }}>
                  ✅ {appliedDiscount} Applied
                </span>
                <button
                  onClick={handleRemoveDiscount}
                  title="Remove discount coupon"
                  style={{
                    marginLeft: "10px",
                    color: "white",
                    border: "none",
                    padding: "5px 10px",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  className="remove_coupen_btn"
                >
                  <IoCloseOutline />
                </button>
              </div>
            )}
            {/* Order Summary */}
            <div
              style={{ marginTop: "10px", backgroundColor: "#F7F7F8" }}
              className="order-summary2"
            >
              <p
                style={{
                  fontSize: "20px",
                  marginBottom: "27px",
                  fontWeight: "500",
                  marginTop: "7px",
                }}
                className="order-summary-title"
              >
                Order Summary
              </p>
              <hr className="order_summery_hr" />
              {isMultiProduct &&
                checkoutProducts.map((product, index) => {
                  const productMonths = getMonthsForProduct(product);
                  const imageSrc = product?.product_description?.includes("BM:4")
                    ? images.three_months
                    : product?.product_img?.length > 0
                      ? product.product_img[0]?.img_video
                      : images.bottel_img;
                  return (
                    <div className="item" key={product?.product_id || index}>
                      <img
                        src={imageSrc}
                        className="order_summary_img"
                        alt={product?.product_name || "product-img"}
                      />
                      <div className="div_card">
                        <p>{product?.product_name}</p>
                        <div className="product-price">
                          {(() => {
                            const couponAmount = getProductCouponAmount(product);
                            const linePrice = Math.max(
                              0,
                              parseNumber(product?.product_price) - couponAmount
                            );
                            const shownPrice = couponAmount > 0
                              ? linePrice.toFixed(2)
                              : product?.product_price;
                            return (
                              <>
                                {couponAmount > 0 && (
                                  <span className="original-price">
                                    ${product?.product_price}
                                  </span>
                                )}
                                <span className="discounted-price">
                                  ${shownPrice}
                                  {productMonths > 1 && (
                                    <>
                                      <br />
                                      {` for ${productMonths} months`}
                                    </>
                                  )}
                                </span>
                                {productMonths > 1 && (
                                  <span className="monthly-info green-sm-text">
                                    ${((couponAmount > 0 ? linePrice : parseNumber(product?.product_price)) / productMonths).toFixed(2)}
                                    /month
                                  </span>
                                )}
                              </>
                            );
                          })()}
                        </div>
                      </div>
                    </div>
                  );
                })}
              {!isMultiProduct && (
              <div className="item">
                {getdata?.product_description &&
                  getdata.product_description.includes("BM:4") ? (
                  <img
                    src={images.three_months}
                    alt="3-month supply"
                    className="order_summary_img"
                  />
                ) : getdata.product_img && getdata.product_img.length > 0 ? (
                  <img
                    src={
                      getdata?.product_img && getdata.product_img.length > 0
                        ? getdata.product_img[0]?.img_video
                        : null
                    }
                    className="order_summary_img"
                    alt="product-img"
                  />
                ) : (
                  <img
                    src={images.bottel_img}
                    className="order_summary_img"
                    alt="product-img"
                  />
                )}

                {/* <img
                  src={
                    getdata?.product_img && getdata.product_img.length > 0
                      ? getdata.product_img[0]?.img_video
                      : images.bottel_img
                  }
                  className="order_summary_img"
                  alt="your medication"
                /> */}
                <div className="div_card">
                  <p>{getdata?.product_name}</p>
                  <div className="product-price">
                    {getdata?.product_category_name === "Weight Loss" ? (
                      // Full pricing for Weight Loss products
                      <>
                        {isDiscountApplied() ? (
                          <>
                            <span className="original-price">
                              ${getdata?.product_price || getproductPrice}
                            </span>
                            <span className="discounted-price">
                              $
                              {calculateDiscountedPrice(getproductPrice).toFixed(2)}{" "}
                              <br />
                              {getdata?.product_description &&
                                getdata.product_description.includes("BM:4") &&
                                `for 3 months`}
                            </span>
                            {/* Show monthly pricing for BM:4 products */}
                            {getdata?.product_description &&
                              getdata.product_description.includes("BM:4") && (
                                <span className="monthly-info green-sm-text">
                                  ${(calculateDiscountedPrice(getproductPrice) / 3).toFixed(2)}
                                  /month
                                </span>
                              )}
                          </>
                        ) : (
                          <>
                            <span className="discounted-price">
                              ${getproductPrice}
                              <br />
                              {getdata?.product_description &&
                                getdata.product_description.includes("BM:4") &&
                                " for 3 months"}
                            </span>
                            {/* Show monthly pricing for BM:4 products without discount */}
                            {getdata?.product_description &&
                              getdata.product_description.includes("BM:4") && (
                                <span className="monthly-info green-sm-text">
                                  ${(getproductPrice / 3).toFixed(2)}/month
                                </span>
                              )}
                          </>
                        )}
                      </>
                    ) : (
                      // Simple price for other products
                      <>
                          <span className="discounted-price">
                            ${getproductPrice} <br />
                            {months > 1 && ` for ${months} months`}
                          </span>
                        {/* Show monthly pricing for BM:4 products in other categories */}
                        {months > 1 && (
                          <span className="monthly-info">
                            ${(getproductPrice / months).toFixed(2)}/month
                          </span>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
              )}
              <div className="item">
                <img
                  src={images.stethoscope}
                  className="order_summary_img"
                  alt=""
                />
                <div className="div_card">
                  <p>Doctor Support and Monitoring</p>
                  <div style={{}} className="product-price">
                    <span
                      style={{ marginRight: "10px" }}
                      className="original-price"
                    >
                      $99
                    </span>
                    <span className="discounted-price">free</span>
                  </div>
                </div>
              </div>
              {/* {getdata.product_category_name === "Weight Loss" && (
                <div className="item">
                  <img
                    src={images.metabolism}
                    className="order_summary_img"
                    alt=""
                  />
                  <div className="div_card">
                    <p>Metabolic testing and blood work included</p>
                    <div style={{}} className="product-price">
                      <span
                        style={{ marginRight: "10px" }}
                        className="original-price"
                      >
                        $75
                      </span>
                      <span className="discounted-price">free</span>
                    </div>
                  </div>
                </div>
              )} */}
              {/* Overnight Shipping start */}
              {activeProductId !== "130" && activeProductId !== "131" && (
                <div className="item">
                  <img
                    src={images.delivery_truck}
                    className="order_summary_img"
                    alt="your medication"
                  />
                  <div className="div_card">
                    <p>Overnight Shipping </p>
                    <div style={{}} className="product-price">
                      <span
                        style={{ marginRight: "10px" }}
                        className="original-price"
                      >
                        $40
                      </span>
                      <span className="discounted-price">free</span>
                    </div>
                  </div>
                </div>
              )}
              {/* Overnight Shipping end */}
              {appliedDiscount && (
                <div className="savings-banner">
                  <MdOutlineCelebration size={25} />
                  <span>
                    You saved{" "}
                    {(() => {
                      const parsedPercent = discount_percent ? parseNumber(discount_percent) : 0;
                      const parsedAmount = discount_amount ? parseNumber(discount_amount) : 0;
                      if (parsedPercent > 0) {
                        return `${Math.trunc(parsedPercent)}%`;
                      } else if (parsedAmount > 0) {
                        return `$${parsedAmount.toFixed(2)}`;
                      }
                      return "";
                    })()}{" "}
                    on your order
                  </span>
                </div>
              )}
              <div
                className="your-total-div"
                style={{
                  borderRadius: "5px",
                  border: isExpanded ? "1px solid #ccc" : "",
                }}
              >
                <div
                  style={{
                    borderRadius: "5px",
                    border: isExpanded ? "" : "1px solid #ccc",
                  }}
                  className={`total-section ${isExpanded ? "expanded" : ""}`}
                  onClick={handleExpandClick}
                >
                  <div className="total-details">
                    <span style={{ marginRight: "10px" }}>
                      {isExpanded ? <FaAngleUp /> : <FaAngleDown />}
                    </span>
                    {/* <CiStar
                      size={25}
                      color="var(--clr-main)"
                      className="star_icon"
                    /> */}

                    <span style={{ color: "var(--clr-main)" }}>
                      {totalText}{" "}
                      {getproductPrice != null && !isNaN(getproductPrice)
                        ? `$${calculateDiscountedPrice(getproductPrice).toFixed(2)}`
                        : ""}
                    </span>
                  </div>
                  <div className="expand-button">
                    {/* <span>{isExpanded ? <FaAngleUp /> : <FaAngleDown />}</span> */}
                  </div>
                </div>

                {isExpanded && (
                  <div style={{ margin: "10px" }} className="expanded-content">
                    {/* Add your expanded content here */}
                    <div
                      style={{
                        borderTop: "0.5px solid gray",
                        marginTop: "-10px",
                        marginBottom: "20px",
                      }}
                    />
                    {appliedDiscount && (
                      <div
                        className=""
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <p style={{ fontWeight: "600", fontSize: "15px" }}>
                          Your Coupon Savings
                        </p>
                        <div style={{}} className="product-price">
                          <span
                            style={{ marginRight: "10px", color: "green" }}
                            className="originsal-price"
                          >
                            {(() => {
                              const parsedPercent = discount_percent ? parseNumber(discount_percent) : 0;
                              const parsedAmount = discount_amount ? parseNumber(discount_amount) : 0;
                              if (parsedPercent > 0) {
                                return `${Math.trunc(parsedPercent)}%`;
                              } else if (parsedAmount > 0) {
                                return `$${parsedAmount.toFixed(2)}`;
                              }
                              return "";
                            })()}
                          </span>
                        </div>
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "10px",
                      }}
                    >
                      <p style={{ color: "black", fontSize: "15px" }}>
                        Subtotal
                      </p>
                      <div style={{}} className="product-price">
                        <span
                          style={{
                            marginRight: "10px",
                            color: "black",
                            fontSize: "15px",
                          }}
                          className="originsal-price"
                        >
                          {/* ${getdata?.product_price} */}
                          {getproductPrice != null && !isNaN(getproductPrice)
                            ? `$${calculateDiscountedPrice(getproductPrice).toFixed(2)}`
                            : ""}
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "10px",
                      }}
                    >
                      <p style={{ color: "black", fontSize: "15px" }}>
                        Estimated Tax
                      </p>
                      <div style={{}} className="product-price">
                        <span
                          style={{
                            marginRight: "10px",
                            color: "black",
                            fontSize: "15px",
                          }}
                          className="originsal-price"
                        >
                          ---
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "10px",
                      }}
                    >
                      <p style={{ color: "black", fontSize: "15px" }}>
                        Shipping
                      </p>
                      <div style={{}} className="product-price">
                        <span
                          style={{
                            marginRight: "10px",
                            color: "black",
                            fontSize: "15px",
                          }}
                          className="originsal-price"
                        >
                          $0
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        borderTop: "0.5px solid gray",
                        marginTop: "10px",
                        marginBottom: "10px",
                        // width: "90%",
                      }}
                    />
                    <div
                      className=""
                      style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <p style={{ fontWeight: "600", fontSize: "15px" }}>
                        Total
                      </p>
                      <div style={{}} className="product-price">
                        <span
                          style={{
                            marginRight: "10px",
                            color: "black",
                            fontWeight: "600",
                            fontSize: "15px",
                          }}
                          className="originsal-price"
                        >
                          {/* ${getdata?.product_price} */}
                          {getproductPrice != null && !isNaN(getproductPrice)
                            ? `$${calculateDiscountedPrice(getproductPrice).toFixed(2)}`
                            : ""}
                        </span>
                      </div>
                    </div>
                    {/* details checkout start footer */}
                    {activeProductId !== "130" && activeProductId !== "131" && (
                      <div
                        style={{
                          marginTop: "20px",
                          borderRadius: "5px",
                          border: "1px solid green",
                          padding: "20px",
                        }}
                      >
                        <p style={{ fontSize: "10px", lineHeight: "22px" }}>
                          By clicking the "Checkout Now" button above, your card
                          will be billed the discounted price of{" "}
                          ${calculateDiscountedPrice(getproductPrice).toFixed(2)}{" "}
                          today to reserve your{" "}
                          {months > 1 ? `${months} month` : "1 month"}{" "}
                          supply of your medication. After you complete the
                          order by clicking the secure "Checkout Now" button
                          above, your information will be securely saved. You
                          will then be asked to complete a short medical history
                          intake and verify your identity. A coreagerx medical
                          professional will review your information, and, if
                          appropriate, prescribe your medication. If you are not
                          eligible for your medication for ANY reason, you will
                          receive a full refund of your purchase price. You have
                          selected the{" "}
                          {months > 1 ? `${months} month` : "monthly"}{" "}
                          package, which includes a{" "}
                          {months > 1 ? `${months} month` : "1 month"}{" "}
                          starter kit. The starter kit includes your medication
                          and detailed instructions on how to properly
                          administer the medication. Each month, you will need
                          to update your prescribing doctor on your progress and
                          they will have the ability to adjust your dosage as
                          needed.
                          {/* billing details per month footer text start */}
                          {(() => {
                            const refillAmount =
                              calculateDiscountedPrice(getproductPrice).toFixed(2);
                            if (months > 1) {
                              return (
                                <>
                                  After your initial medication period, continued treatment is available at ${refillAmount} per {months}-month refill. No automatic billing. You’ll only be charged when you choose to continue.
                                </>
                              );
                            }
                            return (
                              <>
                                Your new billing will continue at ${refillAmount} per month after the first 28 days.
                              </>
                            );
                          })()}
                          {/* billing details per month footer text end */}
                          It will include your medication, unlimited
                          doctor support, and prescription covered. If at
                          anytime you decide not to continue, simply contect us
                          support@coreagerx.com . You will not be billed
                          further. While you are a member, you will have access
                          to chat with your doctor or customer support for any
                          needed assistance.
                        </p>
                      </div>
                    )}
                    {/* details checkout end footer */}
                  </div>
                )}
              </div>
            </div>
            {/* hippa and legit_script images start */}
            <div className="flex gap-2 items-center justify-center">
              <img src={images.hippa} alt="hippa" width={150} />
              <img src={images.legit_script} alt="legit_script" width={150} />
            </div>
            {/* hippa and legit_script images end */}
          </div>
        </div>

        {getskipModel && (
          <div className="skip_modal_main_wrapp">
            <div className="skip_white_part_wrapp">
              <p className="f-16 fw-500" style={{ marginBottom: "10px" }}>
                Thank you for your order,
              </p>
              {/* {getdata.product_category_name === "Weight Loss" ? <p className="f-16 fw-500 mb-2"> */}
              {/* You are now being redirected to the Medical Intake form to complete process */}
              {/* </p> : */}
              <p className="f-16 fw-500 mb-2">
                You are now being redirected to your Member Portal
              </p>
              {/*  }  */}
              <div>
                <button
                  className="btn"
                  style={{ width: "100px" }}
                  onClick={() => {
                    // SkipNextMonth();
                    setSkipModel(false);
                    window.location.assign(targetUrl);
                  }}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        )}

        {showCardDeclinedModal && (
          <div className="card_declined_modal_wrapp">
            <div className="card_declined_modal_content">
              <div className="card_declined_header">
                <IoCloseOutline className="card_declined_x_icon" />
                <h2 className="card_declined_title">Your Card was Declined</h2>
              </div>
              <div className="card_declined_messages">
                <div className="card_declined_message_item">
                  <FaExclamationTriangle className="card_declined_warning_icon" />
                  <span className="card_declined_message_text">
                    Check if you received a text or mobile alert to approve the order.
                  </span>
                </div>
                <div className="card_declined_message_item">
                  <FaExclamationTriangle className="card_declined_warning_icon" />
                  <span className="card_declined_message_text">
                    Try another card as you might not have sufficient funds
                  </span>
                </div>
              </div>
              <button
                className="card_declined_close_btn"
                onClick={() => setShowCardDeclinedModal(false)}
              >
                OK
              </button>
            </div>
          </div>
        )}
        {showStateRestrictedModal && (
          <div className="card_declined_modal_wrapp">
            <div className="card_declined_modal_content">
              <div style={{ position: "absolute", top: "15px", right: "15px" }}>
                <IoCloseOutline 
                  className="card_declined_x_icon" 
                  onClick={() => setShowStateRestrictedModal(false)}
                  style={{ cursor: "pointer", transition: "color 0.2s" }}
                  onMouseEnter={(e) => e.currentTarget.style.color = "#ff7875"}
                  onMouseLeave={(e) => e.currentTarget.style.color = "#ff4d4f"}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", paddingTop: "10px" }}>
                <div style={{ 
                  width: "64px", 
                  height: "64px", 
                  borderRadius: "50%", 
                  background: "#fff7e6", 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "center",
                  marginBottom: "20px"
                }}>
                  <FaExclamationTriangle 
                    style={{ 
                      width: "32px", 
                      height: "32px", 
                      color: "#faad14"
                    }} 
                  />
                </div>
                <h2 style={{ 
                  fontSize: "24px", 
                  fontWeight: "700", 
                  color: "#000", 
                  margin: "0 0 16px 0",
                  textAlign: "center"
                }}>
                  Service Not Available
                </h2>
                <p style={{ 
                  fontSize: "16px", 
                  color: "#595959", 
                  lineHeight: "1.6", 
                  textAlign: "center",
                  margin: "0 0 32px 0",
                  maxWidth: "480px"
                }}>
                  We're sorry, but our services are unfortunately not available in this state.
                </p>
              </div>
              <button
                className="card_declined_close_btn"
                onClick={() => setShowStateRestrictedModal(false)}
                style={{ width: "100%", maxWidth: "200px" }}
              >
                OK
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Checkout2;
